// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDvuWe03A-ZGkBv41P-B2Olu3p938iFRK4",
    authDomain: "lbc-spiritual-gifts.firebaseapp.com",
    projectId: "lbc-spiritual-gifts",
    storageBucket: "lbc-spiritual-gifts.firebasestorage.app",
    messagingSenderId: "637127757037",
    appId: "1:637127757037:web:645998de75207dc2a150e4",
    measurementId: "G-M0N756P1LE"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
